import React from 'react'
import { useIntl } from 'react-intl'
import { mdiAlertCircleOutline } from '@mdi/js'

import theme from 'theme_'
import { MdiIcon } from 'components/Icons'
import { ErrorWrapper, ReturnErrorWrapper } from './styles'
import { loginMessages } from '../../messages'

import CommonButton from 'components/Button/CommonButton'
import LoginCommonLayout from '../LoginCommonLayout'
import { StyledMainHeading } from '../MainHeading/MainHeading'
import { StyledDescriptionText } from '../../styles'
import { SignInFailedProps } from '../../types'

export default function SignInFailed(props: SignInFailedProps) {
  const { formatMessage } = useIntl()

  const { error, setError } = props

  return (
    <LoginCommonLayout>
      <StyledMainHeading>{error.header}</StyledMainHeading>
      <ErrorWrapper>
        <MdiIcon
          path={mdiAlertCircleOutline}
          color={theme.colors.error}
          size={3}
        />
      </ErrorWrapper>

      <StyledDescriptionText>{error.message}</StyledDescriptionText>

      <ReturnErrorWrapper>
        <CommonButton
          type="button"
          variant="secondary"
          onClick={() => setError(null)}
        >
          {formatMessage(loginMessages.goToSignInButton)}
        </CommonButton>
      </ReturnErrorWrapper>
    </LoginCommonLayout>
  )
}
